import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CustomSwipeableDrawer from '../CustomSwipeableDrawer';
import OrderAddressFilter from '../../input/OrderAddressFilter';
import FilterLabel from '../FilterLabel';
import EditTimeForm from '../../input/EditTimeForm';

function DeliveryDetail({ open, onClose }) {
  const { userAddress, date, time, delays } = useSelector(
    ({ main, restaurants, address: selectedAddress, time: selectedTime }) => ({
      isAddressOpen: main.isAddressOpen,
      isEditTimeOpen: main.isEditTimeOpen,
      userAddress: selectedAddress.selectedAddress,
      date: selectedTime.selectedDate,
      time: selectedTime.selectedTime,
      delays: restaurants?.delays,
    })
  );

  const [showOrderAddressFilter, setShowOrderAddressFilter] = useState(false);
  const OrderAddressFilterRef = useRef(null);

  const [showEditTimeForm, setShowEditTimeForm] = useState(false);
  const editTimeRef = useRef(null);

  const stopPropagation = (ev) => ev.stopPropagation();

  const DeliveryDetailForm = (
    <Stack spacing={1} direction="column">
      <Divider />
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="body2" sx={{ ml: 0.5 }} color="text.secondary">
          <FilterLabel time={time} date={date} delays={delays} />
        </Typography>
        <Button
          variant="contained"
          color="grey"
          ref={editTimeRef}
          data-test-id="orderTime"
          onClick={() => setShowEditTimeForm(!showEditTimeForm)}
        >
          Schedule
          <EditTimeForm
            data-test-id="edit-time-form"
            open={showEditTimeForm}
            onClick={stopPropagation}
            actions
            anchorEl={editTimeRef?.current}
            onClose={() => setShowEditTimeForm(false)}
          />
        </Button>
      </Stack>
      <Divider />
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography component="span">
          <Stack direction="row" justifyContent="center" alignItems="center">
            <LocationOnIcon fontSize="small" />
            {userAddress?.address || 'No address'}
          </Stack>
        </Typography>
        <Button
          variant="contained"
          color="grey"
          ref={OrderAddressFilterRef}
          data-test-id="addressChangeButton"
          onClick={() => setShowOrderAddressFilter(!showOrderAddressFilter)}
        >
          Change
          <OrderAddressFilter
            open={showOrderAddressFilter}
            actions
            anchorEl={OrderAddressFilterRef?.current}
            onClose={() => setShowOrderAddressFilter(false)}
          />
        </Button>
      </Stack>
      <Divider />
      <Button
        data-test-id="on-close-button"
        onClick={onClose}
        variant="contained"
      >
        Save Details
      </Button>
    </Stack>
  );

  return (
    <CustomSwipeableDrawer
      open={open}
      onClose={onClose}
      title="Delivery Details"
      data-test-id="new-address-drawer"
    >
      <Box
        data-test-id="stop-propogation-div"
        aria-hidden="true"
        onClick={stopPropagation}
      >
        {DeliveryDetailForm}
      </Box>
    </CustomSwipeableDrawer>
  );
}

DeliveryDetail.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DeliveryDetail;
